export default __webpack_public_path__ + "images/faac3e1480e0a7810758d2959a323c4f-vizdata.svg";